import { render, staticRenderFns } from "./QuestionTopicList.vue?vue&type=template&id=1d1cce9d&scoped=true&"
import script from "./QuestionTopicList.vue?vue&type=script&lang=js&"
export * from "./QuestionTopicList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTopicList.vue?vue&type=style&index=0&id=1d1cce9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1cce9d",
  null
  
)

export default component.exports